import React from "react";
import { Users, BarChart3, Globe, Eye } from "lucide-react";
import { useLanguage } from "../../context/LanguageProvider";

const StatsSection: React.FC = () => {
  const { t } = useLanguage();

  const stats = [
    {
      label: "stats_shops_label",
      value: "2,400+",
      icon: <Users className="h-6 w-6 text-emerald-400" />,
      color: "from-emerald-500/20 to-emerald-500/0",
    },
    {
      label: "stats_transactions_label",
      value: "1.2M+",
      icon: <BarChart3 className="h-6 w-6 text-blue-400" />,
      color: "from-blue-500/20 to-blue-500/0",
    },
    {
      label: "stats_visitors_label",
      value: "85K+",
      icon: <Eye className="h-6 w-6 text-indigo-400" />,
      color: "from-indigo-500/20 to-indigo-500/0",
    },
    {
      label: "stats_countries_label",
      value: "12",
      icon: <Globe className="h-6 w-6 text-purple-400" />,
      color: "from-purple-500/20 to-purple-500/0",
    },
  ];

  return (
    <section className="py-20 bg-accent-cool text-white relative overflow-hidden">
      {/* Background Orbs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/20 rounded-full blur-[120px] -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-secondary/20 rounded-full blur-[120px] translate-y-1/2"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center group">
              <div className={`mx-auto mb-6 w-16 h-16 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center group-hover:bg-white/10 group-hover:border-white/20 transition-all duration-300`}>
                {stat.icon}
              </div>
              <div className="text-3xl md:text-4xl font-black mb-2 tracking-tight bg-clip-text text-transparent bg-gradient-to-b from-white to-white/70">
                {stat.value}
              </div>
              <div className="text-sm font-semibold text-slate-400 uppercase tracking-widest">
                {t(stat.label)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
